import './ShowSelectedElementAndHideOthers.scss';

export const showSelectedElementAndHideOthers = {
  targets: [],
  init() {
    this.containerElement = this.$el;
    this.showAllElements = this.$el.classList.contains('show-all-elements');
    this.targets = [...this.$el.querySelectorAll('[data-target-id]')].map(e => e.dataset.targetId).filter(v => !!v);
    this.targets.forEach((id, i) => {
      let el = document.getElementById(id);
      if (!el) {
        console.warn(`Could not find element #${id} for showSelectedElementAndHideOthers`);
        return;
      }
      el.classList.add('chosen-section');
      if (!this.showAllElements) {
        el.classList.add('hidden');
      }
    });
  },
  show() {
    let id = this.$el.dataset.targetId;
    [...this.targets].forEach(targetID => {
      let button = this.containerElement.querySelector(`button[data-target-id="${targetID}"]`);
      if (targetID === id) {
        button?.classList?.add('active');
      } else {
        button?.classList?.remove('active');
      }

      let elementsToToggle = /^[a-zA-Z0-9]/.test(targetID) ? document.querySelectorAll(`#${targetID}`) : document.querySelectorAll(targetID);
      if (!elementsToToggle) {
        console.info(`Element(s) ${targetID} does not exists, so there can no (un-)hiding be applied.`);
        return;
      }

      elementsToToggle.forEach(el => {
        if (this.showAllElements) {
          if (targetID === id) {
            el.classList.add('current');
            el.classList.remove('not-current');
          } else {
            el.classList.remove('current');
            el.classList.add('not-current');
          }
        } else {
          if (targetID === id) {
            el.classList.remove('hidden');
          } else {
            el.classList.add('hidden');
          }
        }
      })



    });
    // console.log(id)
  }
};